import { Box, CircularProgress } from '@mui/material';

const LoadingSpinner = ({ height = '100%', variant = 'dark', size = 24 }) => {
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height,
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};

export default LoadingSpinner;
